import { hasStylesToRemove, IEditorV3 } from "@azu-business/editor-v3";
import { AioExternalSingleWithSource } from "contexts/hierarchy/interface";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Checks if any external single replacement contains Optional or Notes styles that will be removed.
 *
 * @param singles - Array of external single replacements with EditorV3 content
 * @returns True if any single contains styles to be removed, false otherwise
 */
export const hasStylesToRemoveInSingles = (
  singles: AioExternalSingleWithSource<IEditorV3>[],
): boolean => {
  return singles.some((single) =>
    hasStylesToRemove(single.newText, [...STYLES_TO_DELETE, ...STYLES_TO_CLEAN]),
  );
};
